import React, { useState } from 'react'

function Hello() {
  const [zipCode, setZipCode] = useState('')

  const handleOpenGoogleMaps = () => {
    if (zipCode.trim()) {
      const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent(zipCode)}`
      window.open(mapsUrl, '_blank')
    } else {
      alert('Please enter a zip code')
    }
  }

  const handleInputChange = (e) => {
    setZipCode(e.target.value)
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleOpenGoogleMaps()
    }
  }

  return (
    <div className="hello-page" style={{ padding: '100px 20px', textAlign: 'center', minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '20px', color: '#333' }}>Hello!</h1>
        <p style={{ fontSize: '20px', color: '#666', marginBottom: '40px' }}>Welcome to the Hello page</p>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <input
            type="text"
            placeholder="Enter your zip code"
            value={zipCode}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            style={{
              padding: '12px 15px',
              fontSize: '16px',
              border: '2px solid #ddd',
              borderRadius: '5px',
              transition: 'border-color 0.3s',
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#4CAF50'}
            onBlur={(e) => e.target.style.borderColor = '#ddd'}
          />
          
          <button
            onClick={handleOpenGoogleMaps}
            style={{
              padding: '12px 30px',
              fontSize: '16px',
              fontWeight: 'bold',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
          >
            Open in Google Maps
          </button>
        </div>
      </div>
    </div>
  )
}

export default Hello
